<mat-card appearance="outlined">
	<mat-card-header>
		<mat-card-title>
			{{ 'DISPLAYEDCOLUMNS.' + displayedColumnsId | translate }}
		</mat-card-title>
		<mat-card-subtitle> {{ 'DISPLAYEDCOLUMNS.hint' | translate }} </mat-card-subtitle>
	</mat-card-header>
	<mat-card-content>
		@if (!validCustom) {
			<p style="display: flex; align-content: center; gap: 20px">
				<mat-icon color="warn">warning</mat-icon>
				<span>{{ 'DISPLAYEDCOLUMNS.warning' | translate }}</span>
			</p>
		}
		<div cdkDropListGroup>
			<div cdkDropList [cdkDropListData]="editableColumns" (cdkDropListDropped)="drop($event)">
				@for (col of editableColumns; track col) {
					<mat-divider></mat-divider>
					<div
						style="display: flex; justify-content: space-between; align-items: center; width: 100%"
						cdkDrag
						cdkDragPreviewClass="hide-preview"
						cdkDragLockAxis="y"
						[cdkDragDisabled]="col.disabled"
					>
						<div style="display: flex; align-items: center; gap: 5px">
							<mat-icon [ngStyle]="{ color: col.disabled ? '#D3D3D3' : '' }">drag_indicator</mat-icon>
							<mat-checkbox [disabled]="col.disabled" [checked]="col.active" (change)="toggleColumnActive(col)"> </mat-checkbox>
							<div>{{ 'DISPLAYEDCOLUMNS.' + col.name | translate }}</div>
						</div>
						@if (col.mobile) {
							<mat-icon [matTooltip]="'DISPLAYEDCOLUMNS.mobile_view' | translate">smartphone</mat-icon>
						}
					</div>
				}
			</div>
		</div>
	</mat-card-content>
	<mat-card-actions>
		<div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
			<div style="display: flex; justify-content: flex-start; gap: 5px">
				<button mat-flat-button color="accent" (click)="save()">{{ 'FLIGHTS.save' | translate }}</button>
				<button mat-stroked-button color="primary" (click)="cancel()">{{ 'FLIGHTS.cancel' | translate }}</button>
			</div>
			<button mat-stroked-button (click)="reset()">{{ 'FLIGHTS.reset' | translate }}</button>
		</div>
	</mat-card-actions>
</mat-card>
